import { auth } from '../../../lib/apiList'
import axios from '../../../lib/axios'
import { LoginRequest, SignupRequest } from '../type'

export const forgot = (data: { email: string }): Promise<any> => {
    const response = axios.post(auth.FORGOT_PASSWORD, data)
    return response
}

export const login = (data: LoginRequest): Promise<any> => {
    const response = axios.post(auth.LOGIN, data)
    return response
}

export const resetPassword = (data: { email: string }): Promise<any> => {
    const response = axios.post(auth.RESET_PASSWORD, data)
    return response
}

export const signup = (data: SignupRequest): Promise<any> => {
    return axios.post(auth.SIGNUP, data)
}

export const getProfile = (): Promise<any> => {
    return axios.get(auth.PROFILE)
}
